import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin, Tooltip } from "antd";
import { createDownloadLink, createPresignedDownloadLink } from "helpers";
import $ from "jquery";
import React, { useCallback, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import Image from "../../../components/common/Image/component";
import { CloseModal, Download, InfoIcon } from "../../../components/icons";
import { ENTITY_TYPE } from "../../../constants/phase";
import amplitude from "../../../externals/amplitude";

const BulkDownload = (props) => {
  const { setBulkDownloadZip, entityId } = useOutletContext();
  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;
  const {
    bulkDownloadModalOpen,
    setBulkDownloadModalOpen,
    folderArray,
    setFolderArray,
    downloadClips,
    downloadAllClips,
    loder,
    setLoder,
    downloadAsZipFolder,
    aspectRatio,
    streamId,
    setIsAlertOpen,
    setAlertMessage,
    filters,
    clientSetting,
    getDownloadVideo,
    getDownloadVideoStatus,
    getCloudPreSignedURL,
    entityType,
    userId,
  } = props;
  const [disable, setDisable] = useState(false);
  const downloadClose = () => {
    setBulkDownloadModalOpen(false);
    setFolderArray([]);
  };

  const handleDownloadError = useCallback(
    (value) => {
      const message = value?.data?.message || value?.error?.message || "Something went wrong";

      if (value?.data?.limitError) {
        setIsAlertOpen(true);
        setAlertMessage(message);
        setBulkDownloadModalOpen(false);
      } else {
        notification["error"]({ message });
      }
    },
    [setAlertMessage, setBulkDownloadModalOpen, setIsAlertOpen],
  );
  const handleDownloadSuccess = useCallback(
    (entityId, streamId) => {
      getDownloadVideoStatus({ entityId, streamId });
      amplitude.logEvent("clip_downloaded", { page: "clip" });
    },
    [getDownloadVideoStatus],
  );

  const downloadWithPresignedUrl = useCallback(
    async (clip, url) => {
      try {
        const isProcessingLimit = clientSetting?.permissions?.isProcessingLimit;
        const isWorkspace = entityType === ENTITY_TYPE.WORKSPACES;
        const isProcessingWorkspace = isProcessingLimit && isWorkspace;
        const payloadData = isProcessingWorkspace
          ? {
              url,
              streamId: streamId,
              duration: clip.duration,
              entityId: clip?.entityId,
              contentId: clip._id,
              contentType: clip.type === "highlight" ? "highlight" : "clip",
              userId,
              title: clip.episodeTitle || "",
            }
          : {
              url,
              streamId: streamId,
              entityId,
            };

        const payload = isProcessingWorkspace
          ? await getDownloadVideo(payloadData)
          : await getCloudPreSignedURL(payloadData);

        const { value } = payload;
        if (value?.data?.url) {
          createPresignedDownloadLink(value?.data?.url);
          if (isProcessingWorkspace) {
            handleDownloadSuccess(clip?.entityId, streamId);
          }
        } else {
          throw value;
        }
      } catch (error) {
        throw error;
      }
    },
    [
      clientSetting?.permissions?.isProcessingLimit,
      entityType,
      streamId,
      userId,
      entityId,
      getDownloadVideo,
      getCloudPreSignedURL,
      handleDownloadSuccess,
    ],
  );

  const downloadFile = useCallback(
    async (clip) => {
      const videoUrl =
        clip?.editedVideos.find((v) => v?.aspect_ratio === aspectRatio && v?.event !== "dynamicCropped")?.video_url ||
        clip?.videoUrl;

      try {
        if (clientSetting?.permissions?.allowDirectDownload) {
          createDownloadLink(videoUrl);
        } else {
          await downloadWithPresignedUrl(clip, videoUrl);
        }
      } catch (error) {
        handleDownloadError(error);
      }
    },
    [aspectRatio, clientSetting?.permissions?.allowDirectDownload, downloadWithPresignedUrl, handleDownloadError],
  );

  const checkFileSize = async () => {
    amplitude.logEvent("bulk_download_triggered", {
      page: "clip",
    });
    const bulkUrls = folderArray?.map(
      (o) => o?.editedVideos.find((v) => v?.aspect_ratio === aspectRatio && v?.event !== "dynamicCropped")?.video_url,
    );
    setDisable(true);
    const data = await downloadAllClips({
      fileUrls: aspectRatio
        ? folderArray?.map(
            (o) =>
              o?.editedVideos.find((v) => v?.aspect_ratio === aspectRatio && v?.event !== "dynamicCropped")?.video_url,
          )
        : folderArray.map((d) => d.videoUrl),
    });

    if (data?.value?.size > 524288000) {
      notification["error"]({ message: "Download file size shouldn't exceed 500 mb" });

      amplitude.logEvent("bulk_download_failed", {
        page: "clip",
        error: "Download file size shouldn't exceed 500 mb",
      });
    } else {
      var el = document.querySelector(".download-done");
      $(el).addClass("download-close");
      $(el).removeClass("download-done");
      setBulkDownloadZip({
        downloadStatus: true,
        folderArray: aspectRatio ? bulkUrls : folderArray.map((d) => d.videoUrl),
      });
      downloadAsZipFolder();
      setBulkDownloadModalOpen(false);
    }
    setDisable(false);
  };

  return (
    <>
      {loder ? (
        <Spin indicator={antIcon} className="loader__full" />
      ) : (
        <div>
          <Modal
            isOpen={bulkDownloadModalOpen}
            ariaHideApp={false}
            onRequestClose={downloadClose}
            shouldCloseOnOverlayClick={false}
            contentLabel="Filter Modal"
            portalClassName="react-modal"
            overlayClassName="modal"
            className="modal-dialog react-modal-dialog-xl modal-dialog-centered"
          >
            <div className="modal-content">
              <div className="react-modal-header">
                <h5 className="react-modal-title">
                  Download {""}
                  <Tooltip placement="topLeft" title="Maximum download limit - 500MB">
                    <InfoIcon className="info-icon-main" />
                  </Tooltip>
                </h5>
                <button type="button" onClick={downloadClose} className="btn btn__default">
                  <CloseModal />
                </button>
              </div>
              <div className="react-modal-body">
                <div className="right-btn-block">
                  <div className="button-container text-end mb-3">
                    <button className="btn btn-white me-3" disabled={disable} onClick={checkFileSize}>
                      Download all as Zip{" "}
                    </button>
                  </div>
                </div>

                <div className="inner-container content-control-block styled-scroll">
                  <div className="vv-grid clip-grid-view" grid-size="5">
                    {folderArray &&
                      folderArray?.map((data, index) => {
                        let thumbnail = data.videoThumbnailUrl;
                        if (filters?.aspectRatio) {
                          thumbnail =
                            data?.editedVideos?.find(
                              ({ aspect_ratio, event }) =>
                                aspect_ratio === filters?.aspectRatio &&
                                (event === "autoFlip" || event === "croppedVideos"),
                            )?.thumbnailUrl || data.videoThumbnailUrl;
                        }
                        return (
                          <>
                            <div className="vv-grid-item" key={index}>
                              <div className="vv-video-card">
                                <div className="vv-video-thumb">
                                  <div className="ratio-image">
                                    <Image src={thumbnail} alt="VideoOS" name="thumburl" />
                                  </div>
                                </div>
                                <AccessControl code="downloadClip" page="clips">
                                  <div className="button-container-bottom mt-2">
                                    <button
                                      className="btn btn-white me-3 w-100"
                                      onClick={() => {
                                        downloadFile(data);
                                      }}
                                    >
                                      Download{" "}
                                      <span style={{ marginLeft: "10px" }}>
                                        <Download />
                                      </span>
                                    </button>
                                  </div>
                                </AccessControl>
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
      ;
    </>
  );
};

export default BulkDownload;
